export default "__VITE_ASSET__CDVuQCL3__"